module.exports = {
          srcSet: __webpack_public_path__ + "images/1971-731d639fedbaf5d2d0c2286311e61f03-320.jpg"+" 320w"+","+__webpack_public_path__ + "images/1971-e776e6ffd1fff75ab709807ed4eb95ad-370.jpg"+" 370w",
          images:[ {path: __webpack_public_path__ + "images/1971-731d639fedbaf5d2d0c2286311e61f03-320.jpg",width: 320,height: 251},{path: __webpack_public_path__ + "images/1971-e776e6ffd1fff75ab709807ed4eb95ad-370.jpg",width: 370,height: 290}],
          src: __webpack_public_path__ + "images/1971-731d639fedbaf5d2d0c2286311e61f03-320.jpg",
          toString:function(){return __webpack_public_path__ + "images/1971-731d639fedbaf5d2d0c2286311e61f03-320.jpg"},
          
          width: 320,
          height: 251
        }